export default __webpack_public_path__ + "static/media/attach-files.9c7df846.svg";